import React from 'react';
import { useSelector } from 'react-redux';
import { getClassLabelKey } from '../../../../utils/utils';
import desktop1He from '../../../../assets/stem_craft/Desktop1-he.png';
import desktop1Ar from '../../../../assets/stem_craft/Desktop1-ar.png';
import mobile1He from '../../../../assets/stem_craft/mobile1-he.png';
import mobile1Ar from '../../../../assets/stem_craft/mobile1-ar.png';
import logoStemCraft from '../../../../assets/stem_craft/logoStemCraft.png';
import BtnComponent from '../../../../components/ui/buttons/BtnComponent';
import classes from './StemCraftLanding.module.css';

const StemCraftLanding = ({ contest }) => {

  const { lang, texts } = useSelector(state => state.translate);

  return (
    <div className={classes.contentFrame} >
      <div className={classes.rightSection}>
        <img src={lang === 'he' ? desktop1He : desktop1Ar} alt={contest.contestName} className={classes.heroImage} />
        <img src={lang === 'he' ? mobile1He : mobile1Ar} alt={contest.contestName} className={classes.heroImageMobile} />
      </div>
      <div className={classes.leftSection}>
        <div className={classes.titleContainer}>
        <p className={classes.title}>{texts.contest}</p>
        <img src={logoStemCraft} alt={contest.contestName} className={classes.logoStemCraft} />
        </div>
        <p className={classes.subtitle}>{texts.forClases}{` ${texts[getClassLabelKey(contest.fromClass)]}-${texts[getClassLabelKey(contest.toClass)]}`} </p>
        <p className={classes.smallText}>{texts.weStarted}</p>
        <BtnComponent type="link" text={texts.toContestApplication} link={contest?.providers?.[0]?.url} color="#6C52E3" className={classes.buttonLink} />
      </div>
    </div>
  );
};

export default StemCraftLanding;
